import { forwardRef } from 'react';
import { Select, FormControl, useTheme } from '@mui/material';
import PropTypes from 'prop-types';

import { ErrorWrapper } from '../ValidationError';
import { TextInput } from 'components/Input';
import {
  selectStyles,
  menuProps,
  getPlaceholderStyles,
  StyledFormLabel,
  StyledInputLabel,
} from './styles';
import { ReactComponent as ChevronDown } from 'images/components/chevron-down.svg';

export const SelectInput = forwardRef(
  (
    { hasErrors, value, label, fieldLabel, placeholderStyles, ...rest },
    ref
  ) => {
    const theme = useTheme();
    const selectMenuProps = { ...menuProps(theme), ...rest?.menuProps };
    return (
      <ErrorWrapper>
        <FormControl fullWidth {...rest}>
          {fieldLabel && (
            <StyledFormLabel shrink='false'>{fieldLabel}</StyledFormLabel>
          )}
          {(value === '' || !value?.toString()) && (
            <StyledInputLabel
              shrink={false}
              sx={getPlaceholderStyles(fieldLabel)}
              id='selectLabelId'
              {...placeholderStyles}
            >
              {label}
            </StyledInputLabel>
          )}
          <Select
            IconComponent={ChevronDown}
            input={<TextInput haserrors={!!hasErrors} />}
            MenuProps={selectMenuProps}
            label={label}
            labelId='selectLabelId'
            value={value}
            {...rest}
            sx={selectStyles}
            ref={ref}
          />
        </FormControl>
      </ErrorWrapper>
    );
  }
);

SelectInput.propTypes = {
  hasErrors: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  fieldLabel: PropTypes.string,
};
